export const useConsts = () => {
  const { t } = useI18n()

  const whatIs = {
    headerIcon: '/images/wellbeing/icons/1.png',
    headerTitle: t('wellbeing.whatIs.title'),
    desktopPhotoPosition: 'left',
    photoDesktop: {
      url: '/images/wellbeing/photos/whatis.png',
      public_id: 'wellbeing',
    },
    photoMobile: {
      url: '/images/wellbeing/photos/whatis.png',
      public_id: 'wellbeing',
    },
    photoSide: 'left',
    description: `${t('wellbeing.whatIs.description')}`,
  }
  
  const benefits = [
    {
      headerIcon: '/images/wellbeing/icons/1.png',
      headerTitle: t('wellbeing.benefits.photos.photoTitle1'),
      desktopPhotoPosition: 'right',
      photoDesktop: {
        url: '/images/wellbeing/photos/benefits/1.png',
        public_id: 'wellbeing',
      },
      photoMobile: {
        url: '/images/wellbeing/photos/benefits/1.png',
        public_id: 'wellbeing',
      },
      photoSide: 'right',
      description: `${t('wellbeing.benefits.photos.photoDescription1')}`,
    },
    {
      headerIcon: '/images/wellbeing/icons/2.png',
      headerTitle: t('wellbeing.benefits.photos.photoTitle2'),
      desktopPhotoPosition: 'left',
      photoDesktop: {
        url: '/images/wellbeing/photos/benefits/2.png',
        public_id: 'wellbeing',
      },
      photoMobile: {
        url: '/images/wellbeing/photos/benefits/2.png',
        public_id: 'wellbeing',
      },
      photoSide: 'left',
      description: `${t('wellbeing.benefits.photos.photoDescription2')}`,
    },
    {
      headerIcon: '/images/wellbeing/icons/3.png',
      headerTitle: t('wellbeing.benefits.photos.photoTitle3'),
      desktopPhotoPosition: 'right',
      photoDesktop: {
        url: '/images/wellbeing/photos/benefits/3.png',
        public_id: 'wellbeing',
      },
      photoMobile: {
        url: '/images/wellbeing/photos/benefits/3.png',
        public_id: 'wellbeing',
      },
      photoSide: 'right',
      description: `${t('wellbeing.benefits.photos.photoDescription3')}`,
    },
    {
      headerIcon: '/images/wellbeing/icons/4.png',
      headerTitle: t('wellbeing.benefits.photos.photoTitle4'),
      desktopPhotoPosition: 'left',
      photoDesktop: {
        url: '/images/wellbeing/photos/benefits/4.png',
        public_id: 'wellbeing',
      },
      photoMobile: {
        url: '/images/wellbeing/photos/benefits/4.png',
        public_id: 'wellbeing',
      },
      photoSide: 'left',
      description: `${t('wellbeing.benefits.photos.photoDescription4')}`,
    },
  ]

  const wellbeingsNumbers = [
    {
      number: '90%',
      text: t('wellbeing.wellbeing.tiles.tileHeader1'),
      subtext: t('wellbeing.wellbeing.tiles.tileDesc1'),
    },
    {
      number: '83%',
      text: t('wellbeing.wellbeing.tiles.tileHeader2'),
      subtext: t('wellbeing.wellbeing.tiles.tileDesc2'),
    },
    {
      number: '78%',
      text: t('wellbeing.wellbeing.tiles.tileHeader3'),
      subtext: t('wellbeing.wellbeing.tiles.tileDesc3'),
    },
    {
      number: '46%',
      text: t('wellbeing.wellbeing.tiles.tileHeader4'),
      subtext: t('wellbeing.wellbeing.tiles.tileDesc4'),
    },
  ]

  return {
    whatIs,
    benefits,
    wellbeingsNumbers,
  }
}
